module.exports = {
  "opsMap": {},
};


// WEBPACK FOOTER //
// ./src/i18n/opsMap/en.js